import React, { useState } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { DropdownInput, NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const InputTypeBasic = (props: {rowData: [], field: string, defaults: {}, persist: Function}) => {
  const [data, setData] = useState<object|null>({...props.rowData})
  const inflationOptions = _.map(
    _.get(props, "namedItems.inflation"),
    item => {
      return {value: item.inflationid, label: item.code}
    }
  )
  const inflationDefault = _.get(props.defaults, "rentInflation.inflationNamedItemId")

  function updateData(val:any, field:string):void {
    let localCache = _.cloneDeep(data)
    let nextData = _.cloneDeep(props.rowData)

    _.set(nextData, "inputtype", "basic")
    _.set(nextData, "rentdetail", null)
    _.set(nextData, "amttype", _.get(localCache, "amttype") || props.defaults['rentAmtType'])
    _.set(nextData, "inflationdetail", {
      inflationMode: "namedItem",
      inflationNamedItemId: _.get(localCache, "inflationdetail.inflationNamedItemId") || inflationDefault
    })

    if(field === "inflationdetail.inflationNamedItemId") {
      nextData["inflationdetail"] = localCache["inflationdetail"] = {
        inflationMode: "namedItem",
        inflationNamedItemId: val
      }
    } else {
      nextData[field] = localCache[field] = val
    }
    setData(localCache)
    props.persist(nextData, props.field, props.rowData)
  }

  const attrs = (field) => field_attrs('rent', props.field)(field)(props.rowData, props)
  const unnested_attrs = (field) => field_attrs('rent')(field)(props.rowData, props)

  return (
    <div>
      <SingleRowCarouselState_s>
        <div>
          <label>New</label>
          <NumberInput className="automated new-field" data={data} attrs={unnested_attrs} field="amtnew" readPrecision={4} writePrecision={4} persist={updateData} />
        </div>
        <div>
          <label>Renewal</label>
          <NumberInput className="automated renewal-field" data={data} attrs={unnested_attrs} field="amtrenew" readPrecision={4} writePrecision={4} persist={updateData} />
        </div>
        <div>
        <label>Amt Type</label>
          <DropdownInput className="automated" data={data} attrs={attrs} default={props.defaults['rentAmtType']}
            field="amttype" options={["/Mo", "/Yr", "/Area/Mo", "/Area/Yr"]} persist={updateData} />
        </div>
        <div>
          <label>Inflation</label>
          <DropdownInput className="automated" data={data} field="inflationdetail.inflationNamedItemId"
            default={inflationDefault}
            options={inflationOptions} persist={updateData}
            attrs={attrs}/>
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default InputTypeBasic
